import { CustomFontFamily } from "@redotech/redo-model/brand-kit";

/**
 * Checks if a font family is a custom font
 */
export function isCustomFont(
  fontFamily: string,
  customFontFamilies?: CustomFontFamily[] | null,
): boolean {
  if (!customFontFamilies) return false;
  return customFontFamilies.some((cf) => cf.fontFamily === fontFamily);
}

/**
 * Gets a custom font family object by name
 */
export function getCustomFontFamily(
  fontFamily: string,
  customFontFamilies?: CustomFontFamily[] | null,
): CustomFontFamily | undefined {
  if (!customFontFamilies) return undefined;
  return customFontFamilies.find((cf) => cf.fontFamily === fontFamily);
}

/**
 * Gets the appropriate font-family CSS value with fallbacks.
 * For custom fonts, this returns the custom font with its specific fallback.
 * For system fonts, this returns the font with standard web-safe fallbacks.
 */
export function getFontFamilyWithFallback(
  fontFamily: string,
  customFontFamilies?: CustomFontFamily[] | null,
): string {
  if (!fontFamily) {
    return "Arial, sans-serif";
  }

  if (!customFontFamilies) {
    // For system fonts, add standard fallbacks if not already present
    if (!fontFamily.includes(",")) {
      return `${fontFamily}, Arial, sans-serif`;
    }
    return fontFamily;
  }

  const customFont = customFontFamilies.find(
    (cf) => cf.fontFamily === fontFamily,
  );

  if (customFont) {
    // For custom fonts, use a font-family stack with the custom font first and fallback second
    // This allows the custom font to be used when available while falling back gracefully
    return `"${customFont.fontFamily}", ${customFont.fallbackFont}`;
  }

  // Not a custom font, add standard fallbacks if not already present
  if (!fontFamily.includes(",")) {
    return `${fontFamily}, Arial, sans-serif`;
  }
  return fontFamily;
}
